module.exports = __webpack_public_path__ + "static/media/treasure_orange.34169d78.svg";